import React from "react";
import {NavLink} from "react-router-dom";
import SiteTheme from "../../model/SiteTheme";
import MediaButton from "../social-media/MediaButton";
import KofiButton from "../kofi-button/KofiButton";
import _device_service from "../../services/DeviceService";
import './Footer.scss';

interface FooterProps {
    theme: SiteTheme,
    themeUpdater?: (path: string) => void
}

const Footer = (props: FooterProps) => {

    return (
        <>
            <div id="footer">
                <div id="footer-media-buttons">
                    <ul>
                        <li><MediaButton type="Bluesky" size="mini" code="bsky.social" username="chasetheredfox"/></li>
                        <li><MediaButton type="Twitter" size="mini" username="chasetheredfox"/></li>
                        <li><MediaButton type="Patreon" size="mini" username="chasetheredfox"/></li>
                        <li><MediaButton type="Twitch" size="mini" username="chasetheredfox"/></li>
                        <li><MediaButton type="YouTube" size="mini" username="chasetheredfoxttv"/></li>
                        <li><MediaButton type="Fur Affinity" size="mini" username="chasereynard"/></li>
                        <li><MediaButton type="Deviant Art" size="mini" username="ChaseReynard"/></li>
                    </ul>
                </div>
                <div id="footer-kofi-button">
                    <KofiButton/>
                </div>
                <div id="footer-top-button">
                    <button className="top-button" onClick={() => _device_service.goToTop()}>Return to Top</button>
                </div>
                <div id="footer-credits">
                    Character, concepts, art and site coding
                    by <NavLink to="/contact" target="_blank"
                                rel="noopener noreferrer">Chase the Fox</NavLink><br/>
                    &copy; 2015-2026 Chase the Fox
                </div>
            </div>
        </>
    );
}

export default Footer;